/* eslint-disable comma-dangle */
/* eslint-disable no-unused-expressions */
/* eslint-disable semi */
const { createAsyncThunk, createSlice } = require("@reduxjs/toolkit");
import axios from "axios";
import { API_URL } from "../configs/apiConfig";
export const adminProfile = createAsyncThunk(
  "adminProfile/admin",
  async (_, { rejectWithValue }) => {
    try {
      const adminToken = localStorage.getItem("adminToken");
      if (!adminToken) {
        rejectWithValue("Authentication token not found.");
      }
      const response = await axios.get(`${API_URL}/admin/profile`, {
        headers: {
          Authorization: `Bearer ${adminToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
const initialState = {
  adminData: null,
  loading: false,
  error: null,
};
const adminProfileSlice = createSlice({
  name: "adminProfile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminProfile.pending, (state) => {
        (state.loading = true), (state.error = null);
      })
      .addCase(adminProfile.fulfilled, (state, action) => {
        (state.loading = false),
          (state.adminData = action.payload),
          (state.error = null);
      })
      .addCase(adminProfile.rejected, (state, action) => {
        (state.loading = false), (state.error = action.payload);
      });
  },
});
export default adminProfileSlice.reducer;
